import Glide, {
    Autoplay,
    Breakpoints,
    Controls,
    Swipe,
} from '@glidejs/glide'

(($) => {
    $(document).ready(function () {
        const header = $("#header");

        $(window).scroll(function () {
            if ($(this).scrollTop() > 400) {
                $("#backtotop")
                    .removeClass("opacity-0 invisible")
                    .addClass("opacity-100 visible");
            } else {
                $("#backtotop")
                    .removeClass("opacity-100 visible")
                    .addClass("opacity-0 invisible");
            }
        });

        $("#backtotop").click(function () {
            $("html, body").animate(
                {
                    scrollTop: "0px",
                },
                500
            );
        });

        //LIGHTGALLERY WORDPRESS
        $(".wp-block-gallery,.lightgallery")
            .lightGallery({
                download: false,
                selector: "a",
            })
            .on("onBeforeSlide.lg", function () {
                $(".lg-backdrop").css("opacity", "0.8");
                $(".lg-sub-html").css("opacity", "0");
            });

        //SEARCH FORM
        $("#search").click(function () {
            const form = $("#desktop-searchform");
            form.toggleClass("-translate-y-full opacity-0 invisible");
            if (!form.hasClass("-translate-y-full")) {
                setTimeout(function(){
                    form.find('input[type="search"]').focus();
                }, 300);
            }
        });
        //HEADER

        //Je met des booléens pour éviter que les fonctions spament le removeClass ou addClass a chaque scroll
        let transparentBool = true
        let scrolledDownBool = false
        let lastScrollTop = 0;
        let isfrontpage = false

        if(document.body.classList.contains('home')) { isfrontpage = true }

        if($(window).scrollTop() >= 100 && isfrontpage) {
            header.removeClass("transparent");
        }

        if(window.matchMedia("(min-width: 1024px)").matches) {
            $(window).scroll(function () {

                if (isfrontpage && transparentBool && $(this).scrollTop() >= 100) {
                    header.removeClass("transparent");
                    transparentBool = false
                } else if (isfrontpage && !transparentBool && $(this).scrollTop() < 100) {
                    header.addClass("transparent");
                    transparentBool = true
                }

                let st = $(this).scrollTop();
                if (!scrolledDownBool && st > lastScrollTop){
                    header.addClass("scrolled-down");
                    scrolledDownBool = true
                } else if (scrolledDownBool && st < lastScrollTop){
                    header.removeClass("scrolled-down");
                    scrolledDownBool = false;
                }
                lastScrollTop = st;

            });
        }


        //MENU SUB-MENU
        let currentTab = ""

        document.addEventListener('click', (e) => {
            if(currentTab) {
                if(!(currentTab == e.target)) {
                    currentTab.classList.remove("active")
                    currentTab = ""
                }
            }
            if(e.target.classList.contains("menu-item-has-children") ) {
                e.target.classList.toggle("active")
                currentTab = e.target

                /*
                if(e.target.classList.contains("active") && window.matchMedia("(max-width: 1023px)").matches) {
                    setTimeout(() => {
                        e.target.parentNode.parentNode.scrollTo({ top: e.target.offsetTop - 88, behavior: 'smooth'})
                    },500)
                }
                */
            }
        })

        //SECTION COLUMNS CARDS
        if(window.matchMedia("(max-width: 767px)").matches) {
            const sections = document.querySelectorAll(".section-columns.cards")

            sections.forEach(section => {
                let columns = section.querySelectorAll(".wp-block-column")

                columns.forEach(column => {
                    column.addEventListener("click", () => {
                        column.classList.toggle("active")
                    })
                });
            });
        }

        //MODAL
        $('.modal--event').click(function (e) {
            e.preventDefault();
            var content = $(this).find('.modal--content').html();
            openModal(content);
        });
        $('.modal--bg, #modal .close').click(function () {
            closeModal();
        });
        function openModal(content) {
            $('#modal').find('.container').append(content);
            $('.modal--container').addClass('show');
            $('html, body').addClass('overflow-hidden');
        }
        function closeModal() {
            $('.modal--container').removeClass('show');
            $('html, body').removeClass('overflow-hidden');
            setTimeout(function () {
                $('#modal').find('.container').empty();
            }, 300);
        }

        //LAYOUT FRONT PAGE HEADER
        if(document.body.classList.contains("home")) {
            const slider = document.querySelector(".layout_frontpage_header .glide")

            let glide = new Glide(slider, {
                type: 'carousel',
                autoplay: 4000,
                gap: 0,
            })

            glide.mount()
        }

        //ACCORDIONS
        $('.accordion .accordion--label').click(function (){
            $(this).toggleClass('active');
            $(this).parent().find('.accordion--content').stop().slideToggle(400);
        });

        //SEARCH MAP
        $('.toggle-search-map').click(function (){
            $('#search-map').toggleClass("hide");
        });
    });
})(jQuery);